import { createContext, useState } from 'react';
import api from 'services/api';

const filter = {
  like: '',
  id: '',
  descricao: '',
  grupo_cnae: [],
  codigo: '',
};

export const ClasseCnaeContext = createContext();

export const ClasseCnaeProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [classeCnae, setClasseCnae] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getClasseCnae = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: classeCnae?.filter,
        page: classeCnae?.page,
        size: classeCnae?.size,
        order: classeCnae?.order,
        ...payload,
      });
      setClasseCnae((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <ClasseCnaeContext.Provider
      value={{
        getLoading,
        classeCnae,
        getClasseCnae,
      }}
    >
      {children}
    </ClasseCnaeContext.Provider>
  );
};
